<template>
  <div>
    <HeaderTop ref="shopcar"></HeaderTop>
    <Slider></Slider>
    <div class="center">
      <Store-Header
        :activeName="'storeGoods'"
        :shopName="this.$route.query.shopName"
        :logoTop="this.$route.query.logoTop"
        :shopId="this.$route.query.shopId"
        :tenantId="this.$route.query.tenantId"
      ></Store-Header>
      <Searchtop ref="searchTop"></Searchtop>

      <!-- 查询区域 -->
      <div class="active">
        <div class="left">
          <ul>
            <li
              @click="synthesisChecked"
              :class="checkNum == 0 ? 'checked' : ''"
            >
              综合排序
            </li>
            <li @click="priceChecked" :class="checkNum == 2 ? 'checked' : ''">
              <span>价格</span>
              <div>
                <span
                  class="iconfont icon-zuojiantou"
                  :class="searchData.priceSort == 2 ? 'checkedLi' : ''"
                ></span
                ><span
                  class="iconfont icon-youjiantou"
                  :class="searchData.priceSort == 1 ? 'checkedLi' : ''"
                ></span>
              </div>
            </li>
            <li
              @click="inventoryChecked"
              :class="checkNum == 1 ? 'checked' : ''"
            >
              <span>库存</span>
              <div>
                <span
                  class="iconfont icon-zuojiantou"
                  :class="searchData.stockSort == 2 ? 'checkedLi' : ''"
                ></span
                ><span
                  class="iconfont icon-youjiantou"
                  :class="searchData.stockSort == 1 ? 'checkedLi' : ''"
                ></span>
              </div>
            </li>
          </ul>
        </div>
        <div class="right">
          <Checkbox v-model="hasGoods" @on-change="hasGoodsChange"
            >只显示有货</Checkbox
          >
          <!-- <Checkbox v-model="isActivity" @on-change="isActiveChange"
            >只显示活动</Checkbox
          > -->
        </div>
      </div>
      <div style="display: flex; justify-content: right; margin: 10px 0" >
        <Page
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          size="small"
          :page-size-opts="[30]"
          show-total
          @on-change="changeCurrent"
          @on-page-size-change="changeSize"
        />
        <span
          style="
            line-height: 11px;
            height: 26px;
            padding: 7px 10px;
            border: 1px solid #dcdee2;
            border-radius: 3px;
          "
          >30条/页</span
        >
      </div>

      <!-- 表头 -->
      <Row class="tableHeader" v-if="dataList.length">
        <Col span="1"> </Col>
        <Col span="2">商品图片</Col>
        <Col span="6">基本信息</Col>
        <Col span="3">库存</Col>
        <Col span="3">发货地</Col>
        <Col span="3">价格</Col>
        <Col span="3">购买数量</Col>
        <Col span="3">操作</Col>
      </Row>
      <!-- 内容 -->
      <div class="table">
        <transition-group
          name="more"
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-if="dataList.length"
        >
          <div
            class="tableCenter"
            v-for="(item, index) in dataList"
            :key="item.partId"
          >
            <Row>
              <!-- <Col span="1"></Col>
              <div class="mb10">
                <div v-show="item.source">
                  {{ item.source }}
                </div>-->
              <!-- <div class="mb10">
                这是一个测试我也不知道我到底要写多少个东西出来的就看着写吧!
              </div> -->
              <!-- </div> -->
              <div class="mb10">
                <div class="lm">
                  <!-- <img
                    src="@/assets/images/home/ai.png"
                    alt=""
                    v-show="item.owner || item.source"
                  /> -->
                  <span v-show="item.owner"> {{ item.owner }} </span>
                  <div v-show="item.source" class="w110">
                    {{ item.source }}
                  </div>
                </div>
              </div>
            </Row>
            <Row>
              <Col span="1">
                <div class="activeBox" v-if="item.type == 1">
                  <span class="iconfont icon-a-zu425"></span>
                  <p>优惠</p>
                </div></Col
              >
              <Col span="2" class="flexCenter">
                <img
                  v-if="item.pictureUrl"
                  :src="item.pictureUrl"
                  alt="图片缺失"
                />
                <img
                  v-else
                  src="@/assets/images/shoppingCart/2.png"
                  alt="图片缺失"
                />
              </Col>
              <Col span="6" class="detail" style="padding-left: 28px">
                <div style="cursor: pointer">
                  <!-- <div class="partType">{{ item.typeName }}</div> -->
                  <!-- <div
                    v-if="
                      leagueId ==
                      ('1483458026179055616' || '1483458054591270912')
                    "
                    class="partName"
                    @click="goDetails(item, leagueId)"
                    style="max-width: 223px"
                  >
                    {{ item.carBrandName }}{{ item.stdNameJp }}{{ item.oeCode }}
                  </div> -->
                  <div
                    class="partName"
                    @click="goDetails(item)"
                    style="max-width: 223px"
                  >
                    <span class="partType">{{ item.typeName }} </span>
                    {{ item.oeCode }}
                    <!-- </p> -->
                    <!-- <p> -->
                    {{ item.carBrandName }}

                    <!-- </p> -->
                    <!-- <p> -->
                    {{ item.direction }}{{ item.stdNameJp }}{{ item.oilGrade }}
                  </div>
                </div>
                <ul>
                  <li v-if="item.genuineGuarantee">
                    <span class="iconfont icon-a-lujing153"></span>
                    <p>正品保证</p>
                  </li>
                  <!-- <li> -->
                  <li v-if="item.technicalSupport">
                    <span class="iconfont icon-a-ziyuan4"></span>
                    <p>技术支持</p>
                  </li>
                  <!-- <li> -->
                  <li v-if="item.warrantyService">
                    <span class="iconfont icon-a-ziyuan5"></span>
                    <p>保修服务</p>
                  </li>
                  <!-- <li> -->
                  <li v-if="item.returnPromise">
                    <span class="iconfont icon-a-ziyuan21"></span>
                    <p>退换货承诺</p>
                  </li>
                </ul>
                <div class="oe-p" @mouseleave="closeRelevance(index)">
                  OEM码：
                  <p
                    @mouseenter="getRelevance(item.partId, index, item)"
                    v-if="item.oemCodes.length"
                  >
                    {{ item.oemCodes[0]
                    }}<i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="item.oemCodes.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="item.oemCodes.length > 1"
                  >
                    <div
                      class="relevanceBox"
                      :class="item.isShow ? 'show' : ''"
                    >
                      <!-- 关联原厂件号： -->
                      <p v-for="i in item.oemCodes.slice(1)" :key="i">
                        {{ i }}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span="3" class="flexCenter"
                >{{ item.stock &lt; 10 ? item.stock : '10+' }}/{{
                  item.unitId
                }}</Col
              >
              <!-- 发货地 -->
              <Col span="3" class="w120">
                <div class="oe-p" @mouseleave="closeCity(index)">
                  <p
                    class="w122"
                    @mouseenter="getCity(item.partId, index, item)"
                    v-if="item.shipCityStores.length"
                  >
                    {{ item.shipCityStore.city }}
                    {{ item.shipCityStore.name }}
                    <i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="item.shipCityStores.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="item.shipCityStores.length > 1"
                  >
                    <div
                      class="relevanceBox w33"
                      :class="item.isShows ? 'show' : ''"
                    >
                      <p
                        v-for="i in item.shipCityStores"
                        :key="i.index"
                        class="w22"
                        :class="isCity === i.name ? 'isCityed' : ''"
                        @click="checkCITY(i, item)"
                      >
                        {{ i.city }}
                        {{ i.name }}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span="3"
                ><div class="price">
                  <div v-if="!item.inquiry">
                    <!-- <div> -->
                    <p>￥{{ item.price }}</p>
                    <span
                      v-if="item.type == 1"
                      class="iconfont icon-a-lujing156"
                    ></span>
                    <span v-if="item.type == 1">{{ item.activityTime }}</span>
                  </div>
                  <p v-else>询价</p>
                </div>
              </Col>
              <Col span="3">
                <div class="number">
                  <div class="number-in">
                    <Button
                      style="border-right: 1px solid #dcdee2"
                      class="number-sub"
                      @click="cliSub(item, index)"
                      :disabled="item.Sub"
                      >-</Button
                    >
                    <input
                      oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      :id="index"
                      @blur="BlurNumber(item, index)"
                      v-model="item.maxNum"
                      style="width: 53px; text-align: center; line-height: 31px"
                    />
                    <Button
                      class="number-add"
                      @click="cliAdd(item, index)"
                      :disabled="item.Add"
                      >+</Button
                    >
                  </div>
                  <!-- <InputNumber
                    v-model="item.maxNum"
                    controls-outside
                    :min="item.orderQuantity"
                    :max="item.maxstock"
                    @on-focus="focusNumber(item, index)"
                    @on-change="changeNum(item, index)"
                    @on-blur="double(item, index)"
                  ></InputNumber> -->
                  <div class="number-sp" :class="item.isNumber ? 'show' : ''">
                    库存不足
                  </div>
                  <!-- @on-focus="changeMaxNum(item.stock, index)" -->
                </div>
              </Col>
              <Col span="3">
                <div class="handle" v-if="tenantId !== item.tenantId">
                  <div class="left">
                    <span
                      v-if="item.attention == true"
                      class="iconfont icon-a-ziyuan1"
                      title="收藏"
                      @click="getCollect(item)"
                    ></span>
                    <span
                      v-else
                      class="iconfont icon-a-lujing157"
                      title="收藏"
                      @click="getCollect(item)"
                    ></span>
                    <div
                      v-if="!item.inquiry"
                      class="regular"
                      style="padding-bottom: 3px"
                    >
                      <span
                        class="iconfont icon-a-zu420"
                        title="加入购物车"
                        @click="setShopCat(item, index)"
                      ></span>
                    </div>
                    <div v-else class="noregular">
                      <span class="iconfont icon-a-zu420"></span>
                    </div>
                    <xiaopei
                      :oppositeTenantId="item.tenantId"
                      :partId="item.partId"
                      ><i class="iconfont icon-a-lujing162"></i
                    ></xiaopei>
                  </div>

                  <div class="right">
                    <Button
                      type="error"
                      v-if="item.inquiry == 0"
                      @click="prebuy(item)"
                      :loading="item.buyLoading"
                      >立即购买</Button
                    >
                    <Button
                      v-if="item.inquiry == 1"
                      @click="enquiry(item)"
                      type="primary"
                      >立即询价</Button
                    >
                  </div>
                </div></Col
              >
            </Row>
          </div>
        </transition-group>
        <!-- 数据为空 -->
        <div class="emptyData" v-if="dataList.length == 0">
          <p>
            <span
              ><i
                ><Icon
                  type="ios-alert-outline"
                  size="17"
                />没找到您想要的数据~</i
              ></span
            >
          </p>
        </div>
        <!-- 加载中 -->
        <div class="demo-spin-container" v-if="spinShow">
          <Spin fix></Spin>
        </div>
      </div>
      <div style="display: flex; justify-content: right; margin-bottom: 10px">
        <Page
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          size="small"
          :page-size-opts="[30]"
          show-total
          @on-change="changeCurrent"
          @on-page-size-change="changeSize"
        />
        <span
          style="
            line-height: 11px;
            height: 26px;
            padding: 7px 10px;
            border: 1px solid #dcdee2;
            border-radius: 3px;
          "
          >30条/页</span
        >
      </div>
    </div>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
    <Footer></Footer>
    <footerP></footerP>
  </div>
</template>

<script>
import Footer from '@/views/base/common/footer.vue'
import footerP from '@/views/base/common/footer-p.vue'
import Slider from '../../../base/common/slider.vue'
import HeaderTop from '../../../base/common/header-top.vue'
import StoreHeader from '../../../base/common/store-Header.vue'
import { listData } from '@/views/base/common/listData.js'
import Searchtop from '@/views/components/searchTop.vue'
import xiaopei from '@/views/xiaopei/index.vue'
import enquirytk from '@/views/base/common/enquirytk.vue'
import { getDataList, getattention } from '@/api/goodsList.js'
export default {
  mixins: [listData],
  components: {
    Slider,
    Searchtop,
    StoreHeader,
    HeaderTop,
    xiaopei,
    enquirytk,
    Footer,
    footerP
  },
  watch: {
    '$route.query.inputValue'() {
      this.searchData.keyword = this.$route.query.inputValue.trim()
      this.getDataList()
    },
    '$route.query.shopId'() {
      this.searchData.shopId = this.$route.query.shopId
      this.getDataList()
    }
  },
  data() {
    return {
      enquirydata: {}, // 询价的数据
      hasGoods: '',
      isActive: '',
      isActivity: '',
      checkNum: 0, // 0/销量 1/库存 2/价格
      inventory: '', // 库存查询排序
      inventoryNum: 0, //库存点击次数
      price: '', // 价格查询排序
      priceNum: 0, //价格点击次数
      // leagueId: this.$route.query.tenantId,
      searchData: {
        area: 4,
        brandId: '',
        current: 1,
        inStock: '',
        keyword: this.$route.query.inputValue.trim(),
        sellerTenantId: this.$route.query.tenantId,
        partType: '',
        priceSort: '', // 价格查询排序,
        shopId: this.$route.query.shopId,
        size: 30,
        stockSort: '' // 库存查询排序
      }
    }
  },
  created() {
    this.getDataList()
    console.log(this.$route.query.tenantId)
  },

  methods: {
    // 立即询价
    enquiry(item) {
      this.enquirydata = JSON.parse(JSON.stringify(item))
      this.$refs.enquirytkl.enquirytkc()
    },
    // 询价刷新
    enquirysx() {
      this.$refs.shopcar.getenquirydata()
    },
    async getCollect(item) {
      console.log(item, 'item')
      item.attention = !item.attention
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      const res = await getattention({
        partId: item.partId,
        attention: item.attention
      })
      console.log(res)
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
    },
    // 获取了数据
    async getDataList() {
      console.log(this.searchData)
      // this.searchData.keyword = this.inputValue
      this.spinShow = true
      this.show = true
      let res = await getDataList(this.searchData)
      console.log(res)
      if (res.status == true) {
        this.$nextTick(() => {
          this.brandArr = res.data.partBrandVOList
          this.PartsTypeArr = res.data.partsTypeList
          this.$refs.searchTop.getListBrandType(this.brandArr)
          this.$refs.searchTop.getListPartsType(this.PartsTypeArr)
          this.dataList = res.data.ipage.records
          this.pager.total = res.data.ipage.total
          this.getMaxNum()
        })
      } else {
        this.dataList = []
        this.$refs.searchTop.getListBrandType([])
        this.$refs.searchTop.getListPartsType([])
      }

      this.spinShow = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../supportself/index.less';
@import './index';
</style>
